module.exports = __webpack_public_path__ + "img/logo_happily_stacked.28e432f8.png";